<template>
  <el-dialog :close-on-click-modal=false
             :close-on-press-escape=false
             :show-close=false
             custom-class="xy_dialog"
             width="500px"
             :visible.sync="modifyDialogVisible">
    <el-row>
      <el-col :span="22"
              :offset="1">
        <div style="width:100%;height:0px;"></div>

        <el-form :model="modifyMobileForm"
                 :rules="modifyMobileRules"
                 ref="modifyMobileRuleForm"
                 label-width="0px"
                 class="modifyMobileForm">
          <h2 style="text-align:left">绑定手机号</h2>
          <!-- <h5 style="text-align:left;color:#999999">根据国家法律要求，只有绑定手机号才能享有写作权利</h5> -->
          <div style="width:100%;height:30px;"></div>
          <el-form-item prop="mobile">
            <el-input v-model="modifyMobileForm.mobile"
                      placeholder="请输入新手机号"
                      clearable></el-input>
          </el-form-item>

          <el-form-item prop="imgCaptcha">
            <el-input placeholder="图片验证码"
                      v-model="modifyMobileForm.imgCaptcha">
              <template slot="append"><img :src="imgCaptchaSrc"
                     class="imgCaptcha"
                     @click="changeImgCaptchaSrc"
                     alt="点击刷新" /></template>
            </el-input>
          </el-form-item>
          <el-form-item prop="mobileCaptcha">
            <el-input placeholder="手机验证码"
                      v-model="modifyMobileForm.mobileCaptcha">
              <template slot="append">
                <el-link type="primary"
                         :underline="false"
                         :disabled="mobileMsgSending"
                         @click="sendMobileMsgModifyMobile">{{mobileMsgBtnText}}</el-link>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item label=""
                        prop="agree"
                        style="text-align:left">
            <el-checkbox v-model="modifyMobileForm.agree">我已阅读并了解<el-link :underline=false
                       target="_blank"
                       href="https://writing.yuntianyi.com/static/html/yxzc/index.html">《用户使用权益》</el-link>
            </el-checkbox>
          </el-form-item>
          <div style="width:100%;height:30px;"></div>
          <el-form-item>
            <el-button type="primary"
                       :disabled="!modifyMobileForm.agree"
                       @click="modifyMobile">&nbsp;&nbsp;&nbsp;&nbsp;绑定手机号&nbsp;&nbsp;&nbsp;&nbsp;</el-button>
            <el-button @click="modifyDialogVisible=false">&nbsp;&nbsp;&nbsp;&nbsp;暂不绑定&nbsp;&nbsp;&nbsp;&nbsp;</el-button>
          </el-form-item>

        </el-form>
      </el-col>
    </el-row>
  </el-dialog>
</template>
<script>
import Loading from './js/Loading.vue'
export default {
  components: {
  },
  name: 'bindMobile',
  data: function () {
    var checkMobile = (rule, value, callback) => {
      this.mobileMsgSending = true
      Loading.silentLoading()
      this.axios.get('/webApi/v3/user/isBindedMobile?mobile=' + this.modifyMobileForm.mobile).then(resp => {
        if (resp.data.type === 'false' || !resp.data.type) {
          callback(new Error('手机号已经被使用'));
        } else {
          this.mobileMsgSending = false
          callback();
        }
      })
    };
    return {
      rebackMsgTypes: [],
      rebackForm: {
        contact: '',
        content: '',
        msgType: []
      },
      rebackFormRules: {
        content: [
          { required: true, message: '反馈内容不能为空', trigger: 'blur' }
        ],
        msgType: [
          { type: 'array', required: true, message: '请选择反馈类型', trigger: 'change' }
        ]

      },
      dialogVisible: false,
      userInfo: null,
      modifyMobileForm: {
        mobile: '',
        imgCaptcha: '',
        mobileCaptcha: '',
        agree: true
      },
      modifyMobileRules: {
        mobile: [
          { required: true, message: '手机号不能为空', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '手机号格式错误', trigger: 'blur' },
          { validator: checkMobile, trigger: 'blur' }
        ],
        imgCaptcha: [
          { required: true, message: '图片验证码不能为空', trigger: 'blur' },
          { pattern: /\d{4}$/, message: '图片验证码格式错误', trigger: 'blur' }
        ],
        mobileCaptcha: [
          { required: true, message: '短信验证码不能为空', trigger: 'blur' },
          { pattern: /\d{6}$/, message: '短信验证码格式错误', trigger: 'blur' }
        ]
      },
      imgCaptchaSrc: '',
      mobileMsgSending: true,
      mobileMsgBtnText: '发送验证码',

      curLoginDialog: false,
      modifyDialogVisible: false
    }
  },
  metaInfo () {
    return {
      title: '弈写AI辅助写作'
    }
  },
  methods: {
    submitReback () {
      let _this = this
      this.$refs.rebackForm.validate((valid) => {
        if (valid) {
          let temp = JSON.parse(JSON.stringify(_this.rebackForm))
          temp.msgType = _this.rebackForm.msgType.join(',')
          _this.axios.post('/webApi/m/feedback/add', temp).then(resp => {
            _this.$message({
              message: '信息反馈成功，谢谢!',
              type: 'success'
            })
            _this.dialogVisible = false
          })
        }
      })
    },
    openRebackDialog () {
      this.dialogVisible = true
      let _this = this
      this.axios.get('/webApi/m/feedback/feedbackTypes').then(resp => {
        _this.rebackMsgTypes = resp.data
      })
    },
    sendMobileMsg (form) { // 发送短信验证码
      let _this = this
      let remaindTime = 60
      this.mobileMsgSending = true
      let timer = setInterval(() => {
        _this.mobileMsgBtnText = remaindTime + ' S'
        remaindTime--
        if (remaindTime <= 0) {
          clearInterval(timer)
          _this.mobileMsgSending = false
          _this.mobileMsgBtnText = '发送验证码'
        }
      }, 1000)

      this.axios.post('/webApi/v3/captcha/mobileCaptcha', form).then((response) => {
        _this.$message({
          message: '短信验证码发送成功',
          type: 'success'
        })
      }).catch(e => {
        _this.$message.error('短信验证码发送失败')
        clearInterval(timer)
        _this.mobileMsgSending = false
        _this.mobileMsgBtnText = '发送验证码'
      })
    },
    sendMobileMsgModifyMobile () { // 修改手机号发送验证码
      if (this.modifyMobileForm.mobile === this.userInfo.mobile) {
        this.$message.error('新手机号不能和原手机号一致')
        return
      }
      this.sendMobileMsg(this.modifyMobileForm)
    },
    // 修改手机号
    modifyMobile () {
      let _this = this
      this.$refs.modifyMobileRuleForm.validate((valid) => {
        if (!valid) {
          return
        }
        if (_this.modifyMobileForm.mobile === _this.userInfo.mobile) {
          _this.$message.error('新手机号不能和原手机号一致')
          return
        }

        this.axios.post('/webApi/v3/user/modifyMobile', _this.modifyMobileForm).then((response) => {
          _this.$message({
            message: '手机号修改成功',
            type: 'success'
          })
          _this.userInfo.mobile = _this.modifyMobileForm.mobile
          _this.modifyDialogVisible = false
          _this.getUserInfo()
        })
      })
    },
    changeImgCaptchaSrc () { // 更换验证吗
      this.imgCaptchaSrc = '/webApi/v3/captcha/imgCaptcha?' + Math.random()
    },
    getUserInfo () {
      let _this = this
      this.axios.get('/webApi/v3/user/userInfo').then(resp => {
        _this.userInfo = resp.data
        localStorage.setItem('userInfo', JSON.stringify(resp.data))
      })
    },
    // 修改手机号
    toModifyMobile () {
      this.changeImgCaptchaSrc()
      this.modifyDialogVisible = true
    },
    checkBindMobile () {
      let userInfo = localStorage.getItem('userInfo')
      if (!userInfo) { // 未登录
        return
      }
      let userInfoJson = userInfo ? JSON.parse(userInfo) : {}
      this.userInfo = userInfoJson
      if (userInfoJson.mobile) { // 登录后有手机号
        return
      }
      let wDate = localStorage.getItem('xy_hasShowMobileDialog');
      // showed = false
      if (parseInt(wDate) !== new Date().getDate()) {
        this.toModifyMobile()
        localStorage.setItem('xy_hasShowMobileDialog', new Date().getDate())
      }
    }
  },
  computed: {

  },
  watch: {

  },
  mounted () {
    this.checkBindMobile()
  }
}

</script>

<style lang="less" >
@import "../assets/css/index.less";

.imgCaptcha {
  width: 100px;
}
.modifyMobileForm {
  .el-input-group__append {
    z-index: 99;
    background-color: white;
    padding: 0px 5px;
    border-left: 0px !important;
  }
}
.loginBtn {
  width: 186px;
}
</style>



// WEBPACK FOOTER //
// src/components/bindMobile.vue